module.exports = "/cyber/_next/static/images/participation-rules-bg-mobile-f32da3066f826948455d2d516e4301e1.jpg";